import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/*************注文用*************/
/**
 * 注文一覧：検索条件リストの初期化(状態、支払状態)
 */
export function initOrderSearchList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitOrderSearchList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文一覧：注文基本情報の検索
 */
export function searchOrderBasic(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchOrderBasic, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文一覧：注文No.によると、注文基本情報と明細情報の削除
 */
export function deleteOrderBasicByOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteOrderBasicByOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：基本情報のリスト取得（仕入先、担当者）
 */
export function getInitInfoList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetInitInfoList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：注文No.によると、注文基本情報と明細情報の検索
 */
export function searchOrderDetailByOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchOrderDetailByOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：社内加工原価の取得
 */
export function searchProcessCostByOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchProcessCostByOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：社内加工原価の更新(編集だけ)
 */
export function updateProcessCostByOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateProcessCostByOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：注文基本情報と明細情報の新規追加
 */
export function addOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddOrderDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：注文No.によると、注文基本情報と明細情報の更新
 */
export function updateOrderDetail(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateOrderDetail, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：仕入先によると、注文基本情報と明細情報の検索
 */
export function searchOrderProcSupCode(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchOrderProcSupCode, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 受注製品選択：注文可能な受注情報の取得
 */
export function getOrderableOrder(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetOrderableOrder, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文書出力詳細：注文書出力情報の取得
 */
export function getOrderOutPutInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetOrderOutPutInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文書出力詳細：注文書出力
 */
export function outPutOrderInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.OutPutOrderInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 注文明細：基本情報のリスト取得（異常区分、受注クローズ、支払区分）
 */
export function getInitInfoListForRestock() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetInitInfoListForRestock)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：再入荷情報の検索
 */
export function searchRestockInfoByObOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchRestockInfoByObOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：再入荷情報の更新
 */
export function updateRestockInfoByObOrderNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateRestockInfoByObOrderNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 注文明細：製品クローズ情報の検索
 */
export function searchProductNormalInfoByObQuoteNoInOrder(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchProductNormalInfoByObQuoteNoInOrder, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 注文明細：製品クローズ情報の更新
 */
export function updateProductCloseSelectDataInOrder(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateProductCloseSelectDataInOrder, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/*************注文用*************/

